/**
 * Trạng thái đăng nhập hệ thống KBNN - DVC
 * dtnga3 (10.10.2022)
 */
export default {
  Logout: 0, // Chưa đăng nhập
  Login: 1, // Đã đăng nhập
};
